import { render, staticRenderFns } from "./thirdPartyCompany.vue?vue&type=template&id=1ba0dd63&scoped=true&"
import script from "./thirdPartyCompany.vue?vue&type=script&lang=js&"
export * from "./thirdPartyCompany.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyCompany.vue?vue&type=style&index=0&id=1ba0dd63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0dd63",
  null
  
)

export default component.exports